import * as React from 'react'
import { BOTTOM_PADDING } from '../utils/layout'


export type LayerWrapperProps = {
  zIndex?: number
  pointerEvents?: any
  paddingBottom?: number
  className?: string
  children?: React.ReactNode
}

export const LayerWrapper: React.FC<LayerWrapperProps> = ({
  zIndex,
  pointerEvents = 'none',
  paddingBottom = BOTTOM_PADDING,
  className,
  children,
}) => (
  <div
    className={`tw-flex tw-items-end tw-justify-start${
      className ? ` ${className}` : ''
    }`}
    style={{
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: '100%',
      zIndex,
      pointerEvents,
      paddingBottom,
    }}
  >
    {children}
  </div>
)
